import { __assign, __rest } from "tslib";
import { TableRow as MUTableRow, createStyles, makeStyles, } from '@material-ui/core';
import React, { forwardRef } from 'react';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        head: {
            backgroundColor: theme.palette.background.paper + " !important",
            boxShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
            position: 'relative',
            zIndex: 1,
        },
        root: {
            '&:nth-of-type(even)': {
                backgroundColor: theme.palette.background.paper,
            },
        },
    });
});
export var TableRow = forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var classes = useStyles();
    return (React.createElement(MUTableRow, __assign({ ref: ref, classes: classes, className: props.className }, props), children));
});
//# sourceMappingURL=TableRow.js.map